import { Component, OnInit, ViewChild, Input, OnDestroy } from '@angular/core';
import { TylerMatTableDataSource } from '../../../shared-components/angular-material/extended.class';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { AriaDirective } from '../../../shared-components/directives/aria.directive';
import { FeePayment } from '../fee-payment.model';
import { AdditionalDetailsComponent } from '../additional-details/additional-details.component';

@Component({
    selector: 'fee-payment-details',
    styleUrls: ['./fee-payment-details.component.scss'],
    templateUrl: './fee-payment-details.component.html'
})
export class FeePaymentDetailsComponent implements OnInit, OnDestroy {


    dateCheck:string = '0001-01-01T00:00:00';
    // ----------Angular Material------------------------------------
    angularMatData = new TylerMatTableDataSource();
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    columnsToDisplay = ['Date', 'Description', 'Type', 'Fee', 'Payment', 'RunningBalance', 'BalanceType', 'Details'];
    @Input() feePayments: FeePayment[];
    @Input() v10: boolean;
    //------------Modal window--------------------------------------
    additionalDetailsDialogRef: MatDialogRef<AdditionalDetailsComponent>;

    constructor(private dialog: MatDialog) { }

    ngOnInit() {
        this.angularMatData.data = this.feePayments;

        this.angularMatData.sort = this.sort;
    }

    ngOnDestroy() {
        // POST: ends all subscriptions

    }

    hideDetails(feePayment:FeePayment) {
        if ((feePayment.Course == '' || feePayment.Course == null) && (feePayment.CheckNumber == '' || feePayment.CheckNumber == null) && (feePayment.CheckDate == null || feePayment.CheckDate.toString() == this.dateCheck) &&
            (feePayment.NameOnCheck == '' || feePayment.NameOnCheck == null) && (feePayment.DueDate == null || feePayment.DueDate.toString() == this.dateCheck) && (feePayment.Comments == '' || feePayment.Comments == null))
            return false;
        else
            return true;
    }

    //------------Modal window-----------------------
    showDialog(feePayment: FeePayment) {
        this.additionalDetailsDialogRef = this.dialog.open(AdditionalDetailsComponent, {
            data: {
                SelectedFP: feePayment,
                v10: this.v10
            },
        });

        this.additionalDetailsDialogRef.afterClosed().subscribe(result => { });
    }

    getAriaDetailRowByDate(row: FeePayment): string {
    let colList: string[] = ['Date', 'Description', 'Type', 'Fee', 'Payment', 'RunningBalance'];

    let date:string = new Date(row.Date).toDateString();

    let dataList: string[] = [date,
    row.Description,
    row.Type,
    row.Fee,
    row.Payment,
    row.RunningBalance]

    return AriaDirective.concatAriaStrings(colList, dataList);
  }

}
